import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a33a01a26f67f65e64820cfc9af4e2aa7b from "./generated-ebdc4d1f-04eb-4e80-b1b1-660e34d3f1b5.json";

import a519ba9602b6c2005ae33425663039b36b from "./generated-ae4353a2-05bc-4f6d-b907-e24a0c247882.json";

import aef3954aacac66bbc4326ba3de66ce5efb from "./generated-805e5c9b-d9d9-46d7-9cdb-c8eb772aa84e.json";

import a2718ef9803fcc987876f46d53013f97ab from "./generated-70ff1123-86b4-49df-82ff-b7ade0df91f2.json";

import ac445efdbb20770f127066e63610d6b73b from "./generated-503403d1-974f-4033-af11-388ba0baa76a.json";

import af41451d53c30086d146b2ce993ccabb2b from "./generated-f59ee65b-d758-48cd-a6a4-3af173477c6f.json";

import a542b6a3fc62c7049227abf3f2d406664b from "./generated-e8809275-bf5f-4233-8b6b-df41028dd486.json";

import afebc034bed2fe07d273b9b06a9174902b from "./generated-1f785db9-2e89-428c-88ff-f22d6cfc6e61.json";

import a248fe33da41ba9624728f0b8dd3a5e49b from "./generated-da17bb2b-5f15-4adc-b34d-153841bd577b.json";

import aaf43b69eff6a5b1744a3504b287cec7bb from "./generated-ecbef2dc-513f-4c50-a87c-5de62af9ff3e.json";

import a30f45e5a7c53331b46669aca197e3392b from "./generated-7fdf8f6b-34f4-4560-9164-ecdb697eeab3.json";

import a14c6d428be13b5a39f0bab9c5f509c4cb from "./generated-ed7ba7b5-697d-45ee-a304-7abefacc6909.json";

import ac953fb5d9f8904b6ed3aa3fefe24a0dbb from "./generated-1f707ac9-d32c-4799-8bee-302450a6b096.json";

import ae7647821ab5fdb8093d9af18d62e9c7db from "./generated-b0298ddc-65fb-4405-a5c8-cafe9c01572f.json";

import a2b92eeb30a5cf3fb1b89eb432f162e95b from "./generated-1d0d4491-24c1-41a3-a021-60c34351c755.json";

import af5f7122b6963039756693e1862b41c04b from "./generated-3c36a186-53fc-4066-a211-193f69dcadac.json";

import a7f28826c9240647b26b81e94ece586f9b from "./generated-0ce4ffba-2937-4937-a4fd-76941f6afd9c.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a33a01a26f67f65e64820cfc9af4e2aa7b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a519ba9602b6c2005ae33425663039b36b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aef3954aacac66bbc4326ba3de66ce5efb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a2718ef9803fcc987876f46d53013f97ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ac445efdbb20770f127066e63610d6b73b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(af41451d53c30086d146b2ce993ccabb2b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a542b6a3fc62c7049227abf3f2d406664b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(afebc034bed2fe07d273b9b06a9174902b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a248fe33da41ba9624728f0b8dd3a5e49b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aaf43b69eff6a5b1744a3504b287cec7bb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a30f45e5a7c53331b46669aca197e3392b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a14c6d428be13b5a39f0bab9c5f509c4cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a248fe33da41ba9624728f0b8dd3a5e49b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ac953fb5d9f8904b6ed3aa3fefe24a0dbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ae7647821ab5fdb8093d9af18d62e9c7db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a248fe33da41ba9624728f0b8dd3a5e49b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a2b92eeb30a5cf3fb1b89eb432f162e95b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(af5f7122b6963039756693e1862b41c04b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a7f28826c9240647b26b81e94ece586f9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a2b92eeb30a5cf3fb1b89eb432f162e95b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */